<section id="ngx">

  <!-- === NEW: LOADING OVERLAY === -->
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="loading-content">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <h3>Restoring Session</h3>
      <p>Please wait while we retrieve your workspace...</p>
    </div>
  </div>
  <!-- ============================ -->

  <!-- Main content wrapper - Optional: Hide while loading to prevent layout shift -->
  <div [style.opacity]="isLoading ? '0' : '1'">

    <!-- Alert per il MODELLO -->
    <div class="model-alert-container" *ngIf="!(sessioneService.inferenceParams$ | async)?.model">
      <div class="model-alert-pulse" (click)="openGeneraTestsModal()">
        <i class="ft-alert-triangle"></i>
        <span>Select a model in <b>Generation Settings</b> to proceed.</span>
      </div>
    </div>

    <!-- NUOVO Alert per il TEMPLATE -->
    <div class="model-alert-container" *ngIf="!(sessioneService.selectedTemplate$ | async)">
      <div class="model-alert-pulse" (click)="openGeneraTestsModal()">
        <i class="ft-alert-triangle"></i>
        <span>Select a template in <b>Generation Settings</b> to proceed.</span>
      </div>
    </div>

    <!-- Header Buttons -->
    <div class="row">
      <div class="col-sm-12">
        <div class="d-flex align-items-center">
          <button class="btn btn-outline-primary me-3" (click)="goBackToSessions()">
            <i class="ft-arrow-left"></i> Back to Sessions
          </button>

          <button class="btn btn-outline-dark ml-2" (click)="openGeneraTestsModal()">
            Generation Settings
          </button>

          <button class="btn btn-outline-dark ml-2" (click)="saveCurrentWorkspace()">
            Save Session State
          </button>

          <button class="btn btn-outline-dark ml-2" data-toggle="tooltip" data-placement="top"
            title="Effettua l'esportazione dei test, della story e delle note" (click)="downloadGeneratedTests()">
            Export Workspace
          </button>
        </div>
      </div>
    </div>

    <!-- Session Name & Info
    debug session name value: {{currentSessionName}}-->
    <div class="row">
      <div class="col-sm-12">
        <div class="content-header">Scriptor for {{projectId}}</div>
        <div class="session-name-section mt-2 mb-3">
          <div class="d-flex align-items-center">
            <label class="form-label mb-0 me-2"><strong>Session:</strong></label>

            <!-- Display mode -->
            <div *ngIf="!isEditingSessionName" class="d-flex align-items-center">
              <span class="session-name-display me-2 ml-1">{{currentSessionDisplayName || 'Untitled Session'}}</span>
              <button class="btn btn-sm btn-outline-secondary ml-1" (click)="startEditingSessionName()"
                title="Edit session name">
                <i class="ft-edit-2"></i>
              </button>
            </div>

            <!-- Edit mode -->
            <div *ngIf="isEditingSessionName" class="d-flex align-items-center w-100">
              <input type="text" class="form-control form-control-sm me-2 flex-grow-1 ml-1"
                [(ngModel)]="editingSessionName" (keyup.enter)="saveSessionName()"
                (keyup.escape)="cancelEditingSessionName()" #sessionNameInput placeholder="Enter session name"
                maxlength="100">
              <button class="btn btn-sm btn-success me-1 ml-1" (click)="saveSessionName()" title="Save">
                <i class="ft-check"></i>
              </button>
              <button class="btn btn-sm btn-secondary ml-1" (click)="cancelEditingSessionName()" title="Cancel">
                <i class="ft-x"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Token Stats -->
    <div class="d-flex align-items-left">
      <div class="d-flex flex-column align-items-start ms-2 ml-2">
        <span *ngIf="tokenCount?.prompt_tokens" class="text-muted small me-2">Input: {{tokenCount?.prompt_tokens |
          number:'1.0-0'}}</span>
        <span *ngIf="tokenCount?.completion_tokens" class="text-muted small me-2">Output:
          {{tokenCount?.completion_tokens | number:'1.0-0'}}</span>
        <span *ngIf="tokenCost?.totalCost" class="text-muted small">Total: ${{tokenCost?.totalCost |
          number:'1.2-2'}}</span>
      </div>
      <div class="d-flex flex-column align-items-start ms-2 ml-2">
        <span *ngIf="tokenCount?.prompt_tokens" class="text-muted small me-2">
          Latest Input: +{{getDifferenceTokens(tokenCount?.prompt_tokens, tokenHistory.previousTokenCount.prompt_tokens)
          | number:'1.0-0'}}
        </span>
        <span *ngIf="tokenCount?.completion_tokens" class="text-muted small me-2">
          Latest Output: +{{getDifferenceTokens(tokenCount?.completion_tokens,
          tokenHistory.previousTokenCount.completion_tokens) | number:'1.0-0'}}
        </span>
        <span *ngIf="tokenCost?.totalCost" class="text-muted small">
          Latest Cost: +${{getDifferenceCost(tokenCost?.totalCost, tokenHistory.previousTokenCost.totalCost) |
          number:'1.2-3'}}
        </span>
      </div>
    </div>

    <div class="container-fluid px-4 py-3">
      <!-- Main Upload Container -->
      <div class="main-upload-container">
        <div class="card upload-card">
          <div class="card-body">
            <div class="story-viewer-section mt-3">
              <div class="section-header position-relative">
                <h5 class="mb-1"><i class="ft-book-open text-primary me-2"></i> Core Story Context</h5>
                <p class="text-muted small">Here you can adjust the context of your core Story</p>
                <div class="ambiguities-overlay">
                  <app-ambiguities-alert></app-ambiguities-alert>
                </div>
              </div>
              <div class="story-viewer-container">
                <app-story-viewer></app-story-viewer>
              </div>
            </div>

            <div class="support-files-section mt-3" *ngIf="refinedStoryString">
              <div class="section-header d-flex justify-content-between align-items-center">
                <div>
                  <h5 class="mb-1"><i class="ft-paperclip text-primary me-2"></i> Support Files</h5>
                  <p class="text-muted small">Add supportive files or images</p>
                </div>
                <div>
                  <button class="btn btn-outline-primary btn-sm me-2" (click)="openSupportFileUpload('document')">
                    <i class="ft-file me-1"></i> Add Document
                  </button>
                  <button class="btn btn-outline-primary btn-sm ml-1" (click)="openSupportFileUpload('image')">
                    <i class="ft-image me-1"></i> Add Image
                  </button>
                </div>
              </div>

              <div class="support-files-container" [class.has-files]="supportFiles?.length > 0">
                <div class="empty-state" *ngIf="!supportFiles?.length">
                  <i class="ft-upload-cloud"></i>
                  <p>Click Add File to upload additional supportive files</p>
                </div>
                <div class="support-files-list" *ngIf="supportFiles?.length > 0">
                  <div class="support-file-item" *ngFor="let file of supportFiles; let i = index">
                    <div class="d-flex align-items-center w-100">
                      <i class="ft-file text-primary"></i>
                      <span class="filename">{{file.name}}</span>
                      <div class="flex-grow-1 mx-2">
                        <input type="text" class="form-control form-control-sm" placeholder="File purpose (optional)"
                          [(ngModel)]="file.purpose">
                      </div>
                      <button class="btn btn-icon" (click)="removeSupportFile(i)"><i class="ft-x"></i></button>
                    </div>
                    <div class="mt-2 support-file-viewer">
                      <app-story-viewer [fileName]="file.name"></app-story-viewer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Template and Results Card -->
    <div class="card" *ngIf="refinedStoryString && refinedStoryString.trim() !== ''">
      <div class="card-content">
        <div class="card-body">
          <ngx-spinner>
            <p *ngIf="timing">Response time: {{ elapsedTime }} seconds</p>
          </ngx-spinner>

          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
              <a class="nav-link" [class.active]="activeTab === 'story'" id="story-tab" (click)="activeTab = 'story'"
                role="tab" aria-controls="story" aria-selected="true">
                <i class="ft-book"></i> Template
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [class.active]="activeTab === 'testing'" id="testing-tab"
                (click)="activeTab = 'testing'" role="tab" aria-controls="testing" aria-selected="false">
                <i class="ft-check-square"></i> Testing
              </a>
            </li>
          </ul>

          <div class="tab-content">
            <div class="sticky-button-container" [class.sticky]="isSticky" *ngIf="activeTab === 'story'">
              <div class="form-group text-right">
                <button class="btn btn-success mr-1 mb-1 mb-sm-0" (click)="goToTests()"
                  [disabled]="!(sessioneService.inferenceParams$ | async)?.model || !(sessioneService.selectedTemplate$ | async)"
                  title="{{ (!(sessioneService.inferenceParams$ | async)?.model || !(sessioneService.selectedTemplate$ | async)) ? 'Please select a model and a template from Generation Settings first' : 'Go to Tests' }}"
                  label="Story">
                  Go to Tests <span style="margin-left:10px;"><i class="ft-chevron-right"></i></span>
                </button>
              </div>
            </div>

            <div [hidden]="activeTab !== 'story'" class="tab-pane" [class.active]="activeTab === 'story'" id="story"
              role="tabpanel" aria-labelledby="story-tab">
              <div class="" *ngIf="refinedStoryString && refinedStoryString.trim() !== ''">
                <app-template (generateTestsEvent)="handleGenerateTests($event)"></app-template>
              </div>
            </div>

            <div [hidden]="activeTab !== 'testing'" class="tab-pane" [class.active]="activeTab === 'testing'"
              id="testing" role="tabpanel" aria-labelledby="testing-tab">
              <app-test></app-test>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div> <!-- End of main content wrapper -->


</section>
